import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';

import FILTER_QUERY from 'app/graphql/network/filter';

import MenuDatesProvider from 'app/containers/contexts/menuDates.context';
import { AvailableLinksProvider } from 'app/containers/contexts/availableLinks.context';

import { UserContext } from './UserProvider';


export default function AvailableLinksLandingAdapter(props) {
    const { children } = props;

    // TODO: хорошо бы получать эти данные от фильтер провайдера
    const { data: filterQuery } = useQuery(FILTER_QUERY);

    const userContext = useContext(UserContext);
    const userQuery = userContext.useQuery || {};

    if (!filterQuery) return null;

    return (
        <MenuDatesProvider
            userQuery={userQuery}
            filterQuery={filterQuery}
        >
            <AvailableLinksProvider>
                {children}
            </AvailableLinksProvider>
        </MenuDatesProvider>
    );
}
